import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ButtonWrapper,
  ModalHeader,
  StyledBox,
  StyledBoxCondition,
  StyledBoxFlex,
  StyledBoxInnerText,
  StyledBoxPoint,
  StyledImg,
  StyledLiTop,
  StyledSpanColor,
  StyledTypographyByTitle,
  StyledTypographyDes,
  StyledTypographyLiTopic,
  StyledTypographyLocker,
  StyledTypographyVirtual,
} from "./style";
import CustomButton from "../../common/button/CustomButton";

import profile from "../../../assets/images/right-icon.png";
import close from "../../../assets/images/x-close.png";
import theme from "../../../theme";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

export default function SuccessVirtual({ open, handleClose, handleAccept }) {
  const [agreed, setAgreed] = React.useState(false);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <StyledBox>
          <ModalHeader>
            <StyledBoxFlex>
              <StyledImg
                src={profile}
                alt="profile"
                loading="lazy"
                width={55}
                height={55}
              />
              <Box>
                <StyledTypographyVirtual>
                  Virtual Locker Assigned Successfully!
                </StyledTypographyVirtual>
                <StyledTypographyDes>
                  You can now manage your products inside your virtual locker.
                  Track delivery, confirm <br /> receipt, and request dispatch
                  anytime.
                </StyledTypographyDes>
              </Box>
            </StyledBoxFlex>
            <img
              src={close}
              alt="close"
              loading="lazy"
              height={38}
              style={{ cursor: "pointer" }}
              onClick={() => handleClose()}
            />
          </ModalHeader>

          <StyledBoxCondition>
            <StyledTypographyLocker>
              Virtual Locker Declaration<StyledSpanColor>*</StyledSpanColor>
            </StyledTypographyLocker>
            <StyledBoxInnerText>
              <StyledTypographyByTitle>
                By proceeding, you acknowledge and agree to the following:
              </StyledTypographyByTitle>
              <StyledBoxPoint component="ol">
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    Your Virtual Locker will be activated once the order is
                    created.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    Items will be stored free for 45 days from the date they
                    arrive in the locker.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    After 45 days, a nominal storage fee will be applicable.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    If the payment is not made within 3 days from the due date,
                    the item will be considered disposed and cannot be claimed
                    back.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
              </StyledBoxPoint>

              {/*
              <StyledTypographyTerms>Terms & Conditions</StyledTypographyTerms>
              <StyledUl>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    You will be notified via email/SMS once an item enters the
                    locker. The 45-day storage period begins from that date.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    You may choose to dispatch items anytime within the 45-day
                    window at no extra cost.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    Storage fees once paid are non-refundable.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    Native Shipper is not liable for any item after the disposal
                    date due to non-payment or delay in dispatch.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    Storage fees and durations may change based on your
                    subscription plan or promotions.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
                <StyledLiTop>
                  <StyledTypographyLiTopic>
                    For extended storage beyond 45 days, you will receive a
                    reminder 2 days before the fee becomes due.
                  </StyledTypographyLiTopic>
                </StyledLiTop>
              </StyledUl>
              — Terms shown on /dashboard/locker-v2 blue banner instead
              */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreed}
                    onChange={(e) => setAgreed(e.target.checked)}
                  />
                }
                label="I agree with the Declaration"
              />
            </StyledBoxInnerText>
          </StyledBoxCondition>

          <ButtonWrapper>
            <CustomButton
              padding="16px 94px"
              fontSize={theme.typography.regular.fontSize}
              height="44px"
              btnLabel="Decline"
              btntype={"white"}
              color={theme.palette.custom.lockerValueColor}
              fontWeight={theme.typography.fontWeight.medium}
              border={theme.borders.defaultButton}
              onClick={() => handleClose()}
            />
            <CustomButton
              padding="16px 95px"
              btntype={"primary"}
              color={theme.palette.custom.white}
              btnLabel={"Accept"}
              disabled={!agreed}
              onClick={handleAccept}
            />
          </ButtonWrapper>
        </StyledBox>
      </Modal>
    </>
  );
}
